import { useEffect } from 'react';
import calApi from '../api/calApi';
import { HttpError } from '../api/errors';
import { logBookingError } from '../loggingUtils';
import { CalEventData } from '../types';

interface UseCalEventDataParams {
    teamId?: number;
    organizationId?: number;
    eventSlug?: string;
}

interface UseCalEventDataCallbacks {
    onSuccess: (data: CalEventData) => void;
    onError: () => void;
}

const useCalEventData = (
    { teamId, organizationId, eventSlug }: UseCalEventDataParams,
    { onSuccess, onError }: UseCalEventDataCallbacks
) => {
    useEffect(() => {
        if (teamId && organizationId && eventSlug) {
            calApi
                .getTeamEventType({
                    orgId: organizationId,
                    eventSlug,
                    teamId,
                })
                .then(onSuccess)
                .catch((err) => {
                    onError();
                    try {
                        logBookingError(
                            'Failed to get cal event type by slug',
                            {
                                errorMessage: err?.message,
                                ...(err instanceof HttpError && {
                                    responseStatus: err.responseStatus,
                                    requestUrl: err.requestUrl,
                                    responseBody: JSON.stringify(
                                        err.responseBody
                                    )?.slice(0, 500),
                                }),
                                additionalInfoToLog: {
                                    teamId,
                                    organizationId,
                                    eventSlug,
                                },
                            }
                        );
                    } catch {
                        // last link in the chain: a throw here is unhandled
                    }
                });
        }
    }, [teamId, organizationId, eventSlug]);
};

export default useCalEventData;
